import type {ControladorRedaccionUltimas} from "../ctrl";
import {ESelector} from "../data/auxiliares";
import type {IModuloBase} from "../../../../root/modulo";
import {ModuloRedaccionUltimas} from "./";

export class ModuloRedaccionUltimasRAM extends ModuloRedaccionUltimas {
    /* STATIC */
    public static buildArticulo(cfg: IModuloBase): ModuloRedaccionUltimasRAM[] {
        return [
            new this({
                ...cfg,
                id: "redaccion.ultimas.articulo",
                selector:  ESelector.ARTICULOS_DESARROLLO,
                promocionados: true,
            }),
        ];
    }

    public static buildGeneral(cfg: IModuloBase): ModuloRedaccionUltimasRAM[] {
        const id = "redaccion.ultimas.general";
        return [
            new this({
                ...cfg,
                id,
                selector: ESelector.ARTICULOS_DIRECTORIO,
                promocionados: true,
            }),
        ];
    }

    /* INSTANCE */
    protected async controller(element: Element): Promise<ControladorRedaccionUltimas> {
        const {ControladorRedaccionUltimasRAM} = await import(/* webpackChunkName: "module/redaccion/last/ctrl/ram" */"../ctrl/ram");

        return new ControladorRedaccionUltimasRAM({cfg: this.cfg.global, dominio: this.cfg.dominio, element, selector: this.cfg.selector as ESelector, promocionados: this.cfg.promocionados});
    }
}

export default ModuloRedaccionUltimasRAM;
